import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  container: {
    margin: [30, 0],
    width: '100%',
    display: 'flex',
  },
  messageContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '90%',
  },
  messageBox: {
    margin: [0, 16],
  },
  signature: {
    marginBottom: 12,
    marginLeft: 0,
    textAlign: 'start',
    '& b': {
      fontSize: '1.2em',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/useStyles.js